import { FeaturesMenu } from '../components/FeaturesMenu';

document.addEventListener('DOMContentLoaded', function () {
    new FeaturesMenu();
});
